"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));

var _ModalContent = _interopRequireDefault(require("./ModalContent"));

var _ModalFooter = _interopRequireDefault(require("./ModalFooter"));

var _constants = require("./constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Modal = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);

  var _super = _createSuper(Modal);

  function Modal() {
    var _this;

    (0, _classCallCheck2["default"])(this, Modal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "passPropsToChildrens", function () {
      var _this$props = _this.props,
          children = _this$props.children,
          onClose = _this$props.onClose;
      return React.Children.map(children, function (child) {
        var props = {};

        if (child.type === _ModalHeader["default"] || child.type.displayName === 'ModalHeader') {
          props = {
            onClose: onClose
          };
        }

        return /*#__PURE__*/React.cloneElement(child, props);
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(Modal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onClose = _this$props2.onClose,
          size = _this$props2.size,
          className = _this$props2.className,
          theme = _this$props2.theme,
          dataTestid = _this$props2.dataTestid;
      var customClass = (0, _classnames["default"])('pp-modals', _constants.MODAL_THEMES_CLASSNAME[theme] || _constants.MODAL_THEMES_CLASSNAME[_constants.MODAL_THEMES.LIGHT], _constants.MODAL_SIZES_CLASSNAME[size], className);
      var childrens = this.passPropsToChildrens();
      return /*#__PURE__*/React.createElement("div", {
        "data-testid": dataTestid,
        className: customClass
      }, /*#__PURE__*/React.createElement("div", {
        className: "pp-overlay",
        onClick: onClose
      }), /*#__PURE__*/React.createElement(this.props.contentTag, {
        className: "pp-modals-body"
      }, childrens));
    }
  }]);
  return Modal;
}(React.Component);

(0, _defineProperty2["default"])(Modal, "defaultProps", {
  contentTag: 'div',
  theme: _constants.MODAL_THEMES.LIGHT
});
Modal.Footer = _ModalFooter["default"];
Modal.Header = _ModalHeader["default"];
Modal.Content = _ModalContent["default"];
var _default = Modal;
exports["default"] = _default;